<template>
  <div class="recharge-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb" @click-right="gotoRules">
        <template #left>
          <!-- 这是黑色返回箭头 -->
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="recharge-top">
      <div class="top-tit">{{ $t('lang.NewguyWheelPan.k001') }}</div>
      <div class="top-tip">
        <div>{{ $t('lang.NewguyWheelPan.k002') }}</div>
      </div>

      <div class="rec-date-block">
        <img src="./images/top-bg.png" />

        <template v-if="baseInfo && !baseInfo.hasDrawn">
          <div v-if="cutdown1" class="recharge-date-block">
            <div class="recharge-date">
              <span>{{ $t('lang.ActCommon.k003') }}</span>
              <span class="time">{{ cutdown1.countdownResult.minutes }}</span>
              <span class="step">:</span>
              <span class="time">{{ cutdown1.countdownResult.seconds }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="recharge-con top-mg25">
      <div class="recharge-tit">
        <img src="./images/tips-star.png" />
        <template v-if="baseInfo && baseInfo.hasDrawn === true">
          {{ $t('lang.ActCommon.k056') }}
        </template>
        <template v-else>{{ $t('lang.NewguyWheelPan.k003') }}</template>
        <img src="./images/tips-star.png" />
      </div>

      <div class="bg-block">
        <div class="wheel-pan">
          <div class="outher">
            <div v-if="baseInfo" ref="wapper" class="wapper">
              <div class="part1">
                <div v-if="panData && panData[0]" class="item one" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[0].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[0].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
                <div v-if="panData && panData[1]" class="item two" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[1].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[1].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
                <div v-if="panData && panData[2]" class="item three" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[2].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[2].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
                <div v-if="panData && panData[3]" class="item four" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[3].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[3].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
              </div>
              <div class="part2">
                <div v-if="panData && panData[4]" class="item five" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[4].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[4].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
                <div v-if="panData && panData[5]" class="item six" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[5].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[5].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
                <div v-if="panData && panData[6]" class="item seven" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[6].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[6].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
                <div v-if="panData && panData[7]" class="item eight" :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[7].id }">
                  <div class="text">
                    <div>
                      <span class="discount">{{ panData[7].discount }}</span>
                    </div>
                    <img :src="getMatchImg('coins')" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wheel-pointer"></div>
        </div>

        <div class="recharge-con-block pd-24">
          <!-- Free Spin -->
          <div v-if="baseInfo && baseInfo.hasDrawn === false" class="con-block-btn" @click="handleWheelPan">
            <span>{{ $t('lang.ActCommon.k057') }}</span>
            <div class="btn-tips-root">
              <div class="btn-tips-con">
                <span>{{ $t('lang.ActCommon.k058') }}</span>
                <img src="./images/tips-trangle.png" />
              </div>
            </div>
          </div>

          <template v-if="baseInfo && baseInfo.hasDrawn === true">
            <div class="con-block-btn disable">
              <span>{{ $t('lang.ActCommon.k057') }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-if="baseInfo" class="recharge-con">
      <!-- 已抽奖 -->
      <div v-if="baseInfo.hasDrawn === true" class="bg-block">
        <div class="recharge-con-block">
          <MyPLabel class="dis-tip" :str="$t('lang.NewguyWheelPan.k007')" :numsOption="[{ value: baseInfo.discountDesc }]" />

          <div class="dis-detail">
            <div class="dis-item item1">
              <div class="dis-tit">{{ $t('lang.ActCommon.k050') }}</div>
              <div class="dis-coin">
                <img :src="getMatchImg('coin')" />
                <div>{{ baseInfo.originAmount }}</div>
              </div>
            </div>
            <div class="dis-item item2">
              <div class="dis-tit">{{ $t('lang.ActCommon.k051') }}</div>
              <div class="dis-coin">
                <img :src="getMatchImg('coins')" />
                <div>{{ baseInfo.amount }}</div>
              </div>
            </div>
            <img class="dis-up" src="./images/dis-up.png" />
            <!-- prettier-ignore -->
            <div class="dis-bg">
              +<i>{{ baseInfo.discountDesc }}</i>
            </div>
          </div>

          <div class="rec-fir-deliver">
            <div class="deliver-l">
              <div></div>
            </div>
            <div class="rec-fir-deliver-text">
              {{ $t('lang.NewguyWheelPan.k008') }}
            </div>
            <div class="deliver-r">
              <div></div>
            </div>
          </div>

          <div v-if="baseInfo.presentPropList && baseInfo.presentPropList.length" class="rec-gifts">
            <template v-for="item in baseInfo.presentPropList">
              <div v-if="propsMap[item.propType]" class="gift-item">
                <img :src="getMatchImg(propsMap[item.propType])" />
                <div>x{{ item.number }}</div>
              </div>
            </template>
          </div>
        </div>

        <!-- 去支付按钮-置灰 -->
        <template v-if="baseInfo.ifValid === false">
          <div class="recharge-con-tips">{{ $t('lang.NewguyWheelPan.k014') }}</div>
          <div class="recharge-btn cannot-claim">
            <i>{{ $t('lang.ActCommon.k059') }}</i>
          </div>
        </template>

        <!-- 去支付按钮-可用 -->
        <div v-if="baseInfo.ifValid === true" class="recharge-btn mt-60" @click="handleClaim">
          <img :src="baseInfo.currencyIcon | imgPath" />
          <i>{{ baseInfo.currency }} {{ handleDiv100(baseInfo.price) }}</i>
          <div v-if="cutdown1 && cutdown1.countdownResult" class="discount">
            <img src="./images/clock.png" />
            {{ cutdown1.countdownResult.minutes }}:{{ cutdown1.countdownResult.seconds }}
          </div>
        </div>
      </div>
      <!-- 未抽奖 -->
      <div v-else class="bg-block">
        <div class="spin-tip-block">
          <div class="spin-tip1">{{ $t('lang.NewguyWheelPan.k004') }}</div>
          <div class="spin-tip2">{{ $t('lang.NewguyWheelPan.k005') }}</div>
          <img class="spin-tip3" src="./images/giftbox.png" />
        </div>
      </div>
    </div>

    <div v-if="showDia && baseInfo.discountDesc" class="mask">
      <div class="dialog">
        <div class="dialog-tit">{{ $t('lang.NewguyWheelPan.k006') }}</div>
        <MyPLabel v-if="baseInfo" class="dialog-tip" :str="$t('lang.NewguyWheelPan.k007')" :numsOption="[{ value: baseInfo.discountDesc }]" />

        <div v-if="cutdown1 && cutdown1.countdownResult" class="dialog-time">
          <div class="discount-time">
            <img src="./images/clock.png" />
            {{ cutdown1.countdownResult.minutes }}:{{ cutdown1.countdownResult.seconds }}
          </div>
        </div>

        <div v-if="baseInfo" class="dialog-detail">
          <div class="dialog-item item1">
            <div class="dialog-tit">Regular</div>
            <div class="dialog-coin">
              <img :src="getMatchImg('coin')" />
              <div>{{ baseInfo.originAmount }}</div>
            </div>
          </div>
          <div class="dialog-item item2">
            <div class="dialog-tit">Now</div>
            <div class="dialog-coin">
              <img :src="getMatchImg('coins')" />
              <div>{{ baseInfo.amount }}</div>
            </div>
          </div>
          <img class="dialog-up" src="./images/dis-up2.png" />
          <!-- prettier-ignore -->
          <div class="dialog-bg">
            +<i>{{ baseInfo.discountDesc }}</i>
          </div>
        </div>

        <div class="dialog-deliver">
          <div class="deliver-l">
            <div></div>
          </div>
          <div class="dialog-deliver-text">
            {{ $t('lang.NewguyWheelPan.k008') }}
          </div>
          <div class="deliver-r">
            <div></div>
          </div>
        </div>

        <div v-if="baseInfo && baseInfo.presentPropList && baseInfo.presentPropList.length" class="dialog-gifts">
          <template v-for="item in baseInfo.presentPropList">
            <div v-if="propsMap[item.propType]" class="gift-item">
              <img :src="getMatchImg(propsMap[item.propType])" />
              <div>x{{ item.number }}</div>
            </div>
          </template>
        </div>

        <div class="recharge-btn" @click="handleClaim">
          <img :src="baseInfo.currencyIcon | imgPath" />
          <i>{{ baseInfo.currency }} {{ handleDiv100(baseInfo.price) }}</i>
        </div>
      </div>

      <img class="dialog-close" src="./images/close.png" @click="handleCloseDia" />
    </div>
  </div>
</template>

<script>
import { apiAct, apiDraw } from './apidir/api.js'

import CountDownClass from '@/utils/count-down.js'

const angles = ['-22.5', '292.5', '247.5', '202.5', '157.5', '112.5', '67.5', '22.5']
export default {
  data() {
    return {
      // 转盘数据
      isWheeling: false,
      panData: [],

      appInfo: null,

      // 页面数据
      baseInfo: null,
      // 倒计时
      cutdown1: null,
      cutdown2: null,

      showDia: false
    }
  },
  methods: {
    gotoRules() {
      this.$router.push({ path: '/newguy-wheel-pan-rules' })
    },
    handleCloseDia() {
      this.showDia = false

      try {
        if (document.body) {
          let top = 5000
          if (document.body.scrollHeight) {
            top = document.body.scrollHeight
          }
          document.body.scrollTo({ top: top, behavior: 'smooth' })
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    },
    // 转盘方法
    handleWheelPan() {
      if (!this.baseInfo.hasDrawn && !this.isWheeling) {
        apiDraw().then((resData) => {
          if (resData && !resData.error) {
            this.resolveData(resData.lastDrawId, () => {
              this.baseInfo = resData
              if (this.baseInfo && this.baseInfo.hasDrawn && this.baseInfo.ifValid) {
                this.showDia = true
              }
            })
          }
        })

        // mock
        // this.resolveData(10, () => {
        //   // this.baseInfo = {}
        //   this.showDia = true
        // })
      }
    },
    resolveData(lastDrawId, cbFn) {
      const tempArr = this.panData || []
      const originIndex = tempArr.findIndex((item) => item.id === lastDrawId)
      if (originIndex > -1) {
        this.doWheelPan(angles[originIndex], cbFn)
        this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'newguy-wheel-pan-click-wheel' })
      }
    },
    doWheelPan(angle, fn) {
      this.isWheeling = true

      let begin = 0
      const basic = 1800

      const timer = setInterval(() => {
        if (begin > basic + angle) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
        }
        this.$refs.wapper.style.transform = 'rotate(' + begin + 'deg)'
        begin += Math.ceil(basic + angle - begin) * 0.1
      }, 70)
    },
    locationPan() {
      try {
        if (this.baseInfo && this.baseInfo.hasDrawn && this.baseInfo.lastDrawId) {
          // 定位到上次选中
          const tempArr = this.panData || []
          const originIndex = tempArr.findIndex((item) => item.id === this.baseInfo.lastDrawId)
          if (originIndex > -1) {
            const angle = angles[originIndex]
            this.$refs.wapper.style.transform = 'rotate(' + angle + 'deg)'
          }

          // 滚动到底部
          if (document.body) {
            let top = 5000
            if (document.body.scrollHeight) {
              top = document.body.scrollHeight
            }
            document.body.scrollTo({ top: top, behavior: 'smooth' })
          }
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    },
    // 数据相关
    stopAct() {
      if (this.baseInfo) {
        this.baseInfo.ifValid = false
        this.baseInfo.hasDrawn = false
      }
      //
      else {
        this.initData()
      }
    },
    // 业务方法
    async handleClaim() {
      // 调用接口校验当前状态
      const nowState = await apiAct()
      if (!nowState || (nowState && !nowState.hasDrawn)) {
        this.initData()
        return
      }
      // 初始数据校验当前状态
      if (!this.baseInfo) {
        return
      }

      // 支付基础参数
      const payQuery = {
        scene: 'activity',
        tierId: this.baseInfo.tierId,
        activityType: this.baseInfo.activityType,
        gid: this.baseInfo.gid,
        productId: this.baseInfo.productId,
        amount: this.baseInfo.amount,
        backType: 'previous',
        useWebPay: '1'
      }

      this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'newguy-wheel-pan-click-topay' })

      // echo 支付页面
      const appChannel = this.getChannel()
      if (appChannel === 'eca' || appChannel === 'ecg') {
        this.$router.push({
          path: '/echo-pay',
          query: payQuery
        })
        return
      }

      // 其他 支付页面
      this.$router.push({
        path: '/pay',
        query: payQuery
      })
    },
    resolceResData(resData) {
      this.baseInfo = resData

      // 初始化 转盘数据
      if (resData.wheelConfig && resData.wheelConfig && resData.wheelConfig.length) {
        this.panData = resData.wheelConfig.map((item) => {
          return {
            id: item.id,
            discount: item.desc.replace('%', ''),
            ratio: null
          }
        })
      }

      this.$nextTick(() => {
        this.locationPan()
      })

      this.cutdown1 = new CountDownClass()
      this.cutdown1.initCountDown(resData.expireTimeMills, 'MS', true)
    },
    // 获得页面数据
    initData() {
      apiAct().then((resData) => {
        if (resData) {
          // 正常
          if (!resData.error) {
            this.resolceResData(resData)
            return
          }
          // 异常
          if (resData.error.status === 598) {
            if (this.baseInfo) {
              this.baseInfo.ifValid = false
            }
          }
        }
      })
    },
    mockData() {
      const resData = {
        activityType: 18,
        amount: 2040,
        currency: '$',
        currencyPrice: 999,
        discountDesc: '40%',
        expireSeconds: 100539,
        expireTimeMills: 1770707117811,
        gid: '3',
        hasDrawn: true,
        ifValid: true,
        lastDrawId: 9,
        originAmount: 1700,
        originPrice: 2788,
        presentPropList: [
          {
            number: 5,
            propId: 0,
            propType: 15
          },
          {
            number: 5,
            propId: 0,
            propType: 15
          }
        ],
        price: 999,
        productId: 'imee_9.99_1',
        showThirdPay: false,
        wheelConfig: [
          {
            desc: '750',
            id: 7
          },
          {
            desc: '850',
            id: 8
          },
          {
            desc: '1000',
            id: 9
          },
          {
            desc: '2000',
            id: 10
          },
          {
            desc: '3000',
            id: 11
          },
          {
            desc: '4000',
            id: 12
          },
          {
            desc: '5000',
            id: 13
          },
          {
            desc: '6000',
            id: 14
          }
        ]
      }
      this.resolceResData(resData)
    },
    refresh() {
      this.initData()
    }
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }

    this.initData()

    window.refresh = this.refresh

    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'newguy-wheel-pan' })
  },
  beforeRouteLeave(to, from, next) {
    try {
      if (document.body) {
        document.body.scrollTo({ top: 0 })
      }
    } catch (err) {
      console.log('try catch err:', err)
    }
    next()
  }
}
</script>

<style lang="less" scoped>
.recharge-root {
  width: 375px;
  margin: auto;
  min-height: 100vh;
  padding-bottom: 90px;
  background-color: #ffdc6a;

  .custom-nav-block {
    background-color: #ff9f4c;
  }

  .recharge-top {
    position: relative;
    background-color: #ff9f4c;
    padding-top: 20px;
    .top-tit {
      padding: 0 15px;
      text-align: center;
      font-family: 'TikTokSans-Bold';
      font-size: 32px;
      font-style: normal;
      font-weight: bold;
      line-height: 36px;
      position: relative;
      color: #fff84f;
      text-shadow: 2px 2px 0 #321904;
    }

    .top-tip {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        color: #fff;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 20px;
        font-style: normal;
        font-weight: bold;
        line-height: 20px;

        display: inline-flex;
        padding: 7px 10px;
        justify-content: center;
        align-items: center;

        border-radius: 20px;
        background: #ff8900;
      }
    }

    .rec-date-block {
      position: relative;
      width: 100%;
      font-size: 0;
      margin-top: -45px;
      > img {
        width: 100%;
      }

      .recharge-date-block {
        position: absolute;
        top: 75px;
        left: 50%;
        transform: translateX(-50%);

        border-radius: 100px;
        background: #321904;
        border: 4px solid #321904;

        .recharge-date {
          padding: 2px 16px;
          border-radius: 100px;
          border: 1px solid rgba(255, 248, 248, 0.8);
          background: #321904;
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            color: #ffffff;
            font-family: 'TikTokSans-Regular';
            font-size: 20px;
            line-height: 26px;
            margin: 0 2px;
            white-space: nowrap;

            &.time {
              color: #93ea07;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              min-width: 28px;
            }

            &.step {
              color: #93ea07;
              display: inline-flex;
            }
          }
        }
      }
    }
  }

  .recharge-con {
    position: relative;
    width: 343px;
    margin: 10px auto;
    padding: 6px;
    border-radius: 30px;
    background: #ff9424;

    .recharge-tit {
      margin: 4px 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: 'TikTokSans-Regular';
      font-size: 20px;
      font-weight: bold;
      line-height: 26px;
      color: #fff84f;
      text-shadow: 2px 2px 0 #321904;

      img {
        width: 17px;
        height: 17px;
        margin: 0 4px;
      }
    }

    .bg-block {
      border-radius: 24px;
      background: #fff6da;
      padding: 24px 0;

      .wheel-pan {
        width: 291px;
        height: 291px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(./images/wheel-pan.png) top left / 100% auto no-repeat;
        position: relative;

        .wheel-pointer {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 99;
          margin-top: -30px;
          margin-left: -20px;
          width: 40px;
          height: 52px;
          background: url(./images/wheel-pointer.png) top left / 100% auto no-repeat;
        }
      }

      .spin-tip-block {
        padding: 0 17px;
        .spin-tip1 {
          color: #321904;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 18px;
          font-weight: 600;
          line-height: 22px;
        }
        .spin-tip2 {
          margin-top: 10px;
          color: #8f8277;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
        }
        .spin-tip3 {
          width: 176px;
          height: 130px;
          display: block;
          margin: auto;
        }
      }

      .recharge-con-block {
        width: 295px;
        margin: 10px auto;
        border-radius: 24px;
        background: #fff6da;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .con-block-btn {
          min-width: 243px;
          min-height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          border: 4px solid #fdecd5;
          background: linear-gradient(180deg, #fe3740 0%, #fb7c2e 100%);
          box-shadow: 0 2px 4px 0 rgba(191, 88, 23, 0.2), 0 2px 1px 2px rgba(255, 255, 255, 0.8) inset;

          color: #fffcff;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;

          position: relative;

          .btn-tips-root {
            position: absolute;
            top: -23px;
            right: -12px;
            min-width: 72px;
            min-height: 32px;

            .btn-tips-con {
              min-width: 72px;
              height: 24px;
              padding: 0 12px;
              border-radius: 8px;
              background: linear-gradient(180deg, #e0ff1a 0%, #93ea07 100%);

              color: #3e5600;
              text-align: center;
              font-family: 'TikTokSans-Regular';
              font-size: 15px;
              font-weight: 500;

              position: relative;
              img {
                width: 14px;
                height: 8px;
                position: absolute;
                bottom: -8px;
                right: 20px;
              }
            }
          }
        }

        .con-block-btn.disable {
          border-radius: 16px;
          border: 4px solid #f1f1f1;
          background: linear-gradient(180deg, #c1c1c1 0%, #e4e4e4 100%);
          box-shadow: 0 2px 4px 0 rgba(136, 136, 136, 0.2), 0 2px 1px 2px rgba(255, 255, 255, 0.8) inset;
        }

        .recharge-tips {
          margin: 8px 0;
          color: #321904;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        .dis-tip {
          color: #321904;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }

  .dis-detail {
    width: 100%;
    padding: 36px 5px 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    position: relative;
    .dis-item {
      width: 130px;
      display: flex;
      flex-direction: column;
      .dis-tit {
        font-family: 'Inter-Tight';
        font-size: 12px;
        text-align: left;
        font-weight: bold;
        line-height: 14px;
        padding: 4px 12px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .dis-coin {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        padding: 8px 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;

        font-family: 'TikTokSans-Regular';
        font-size: 24px;
        font-style: italic;
        font-weight: bold;
        line-height: 28px;
        flex-wrap: wrap-reverse;

        img {
          margin: 0 3px;
        }
      }
    }
    .item1 {
      .dis-tit {
        background: #ffeac5;
        color: #844920;
      }
      .dis-coin {
        background: #fff9ee;
        color: #d87835;
        img {
          width: 32px;
        }
      }
    }

    .item2 {
      .dis-tit {
        background: #ff9424;
        color: #ffffff;
      }
      .dis-coin {
        background: #fff0b0;
        color: #c1270d;
        img {
          width: 48px;
        }
      }
    }

    .dis-up {
      width: 40px;
      height: 40px;
      position: absolute;
      left: 50%;
      bottom: 13px;
      margin-left: -20px;
    }

    .dis-bg {
      width: 66px;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(./images/dis-bg.png) top left / 100% 100% no-repeat;

      position: absolute;
      right: -10px;
      top: 0;

      color: #ffffff;
      font-family: 'InterTight';
      font-size: 15px;
      line-height: 19px;
      font-style: italic;
      font-weight: bold;
      i {
        font-size: 18px;
        line-height: 22px;
        font-style: italic;
      }
    }
  }

  .rec-fir-deliver {
    width: 100%;
    margin-top: 24px;
    font-family: 'TikTokSans-Regular';
    font-size: 17px;
    color: #333333;
    height: 20px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .deliver-l,
    .deliver-r {
      flex: 1;
      position: relative;
      opacity: 0.5;
    }
    .deliver-l {
      div {
        width: 100%;
        height: 1px;
        background: linear-gradient(270deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
      }
    }
    .deliver-r {
      div {
        width: 100%;
        height: 1px;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #333333 100%);
      }
    }
    .rec-fir-deliver-text {
      margin: 0 3px;
    }
  }

  .rec-gifts {
    width: 100%;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    .gift-item {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 30px;
        margin: 0 5px;
      }
      color: #321904;
      font-family: 'Inter-Tight';
      font-size: 20px;
      font-style: italic;
      font-weight: bold;
      line-height: normal;
    }
  }

  .recharge-con-tips {
    margin-top: 26px;
    color: #321904;
    text-align: center;
    font-family: 'TikTokSans-Regular';
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .recharge-btn {
    width: 262px;
    min-height: 52px;
    margin: 12px auto 0;
    background: #ffe242;
    border-radius: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;

    img {
      width: 24px;
      margin: 0 3px;
    }

    i {
      color: #321904;
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 20px;
      font-weight: 600;
    }

    .discount {
      position: absolute;
      right: 0;
      top: -12px;
      width: 100px;
      line-height: 24px;
      padding: 0 12px;

      display: inline-flex;
      justify-content: flex-start;
      align-items: center;

      color: #fff;
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 15px;
      border-radius: 100px;
      background: #ff5a4a;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .cannot-claim {
    pointer-events: none;
    background: #cccccc;

    i,
    span {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    background: var(--mask-black-75, rgba(0, 0, 0, 0.75));

    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .dialog {
      width: 327px;
      min-height: 200px;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 16px;
      background: linear-gradient(180deg, #ffe242 0%, #fff 100%), #fff;
      position: relative;

      .dialog-tit {
        color: #6f3613;
        text-align: center;
        font-family: 'TikTokSans-Bold';
        font-size: 28px;
        font-weight: bold;
        line-height: 32px;
      }

      .dialog-tip {
        margin-top: 2px;
        color: #c0880e;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
      }

      .dialog-time {
        margin-top: 9px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .discount-time {
          padding: 6px 8px;

          display: inline-flex;
          justify-content: center;
          align-items: center;

          color: #fff;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          line-height: 18px;
          border-radius: 100px;
          background: #ff5a4a;

          img {
            width: 16px;
            height: 16px;
            margin: 0 3px;
          }
        }
      }

      .dialog-detail {
        width: 100%;
        padding: 36px 30px 0;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        position: relative;
        .dialog-item {
          width: 130px;
          display: flex;
          flex-direction: column;
          .dialog-tit {
            font-family: 'Inter-Tight';
            font-size: 12px;
            font-weight: bold;
            text-align: left;
            line-height: 14px;
            padding: 4px 12px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          }
          .dialog-coin {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            padding: 8px 0;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;

            font-family: 'TikTokSans-Regular';
            font-size: 24px;
            font-style: italic;
            font-weight: bold;
            line-height: 28px;

            flex-wrap: wrap-reverse;

            img {
              margin: 0 3px;
            }
          }
        }
        .item1 {
          .dialog-tit {
            background: #fff6c6;
            color: #c0880e;
          }
          .dialog-coin {
            background: #fffbe4;
            color: #f3a30c;
            img {
              width: 32px;
            }
          }
        }

        .item2 {
          .dialog-tit {
            background: #ff9b7e;
            color: #ffffff;
          }
          .dialog-coin {
            background: linear-gradient(180deg, #ff8a5e 0%, #ff495c 100%);
            color: #ffe242;
            img {
              width: 48px;
            }
          }
        }

        .dialog-up {
          width: 40px;
          height: 40px;
          position: absolute;
          left: 50%;
          bottom: 13px;
          margin-left: -20px;
        }

        .dialog-bg {
          width: 66px;
          height: 66px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url(./images/dis-bg.png) top left / 100% 100% no-repeat;

          position: absolute;
          right: 15px;
          top: 0;

          color: #ffffff;
          font-family: 'InterTight';
          font-size: 15px;
          line-height: 19px;
          font-style: italic;
          font-weight: bold;
          i {
            font-size: 18px;
            line-height: 22px;
            font-style: italic;
          }
        }
      }

      .dialog-deliver {
        width: 100%;
        margin-top: 24px;
        font-family: 'TikTokSans-Regular';
        font-size: 17px;
        color: #9c8821;
        height: 20px;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .deliver-l,
        .deliver-r {
          flex: 1;
          position: relative;
          opacity: 0.5;
        }
        .deliver-l {
          div {
            width: 100%;
            height: 1px;
            background: linear-gradient(270deg, #9c8821 0%, rgba(255, 255, 255, 0) 100%);
          }
        }
        .deliver-r {
          div {
            width: 100%;
            height: 1px;
            background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #9c8821 100%);
          }
        }
        .dialog-deliver-text {
          margin: 0 3px;
        }
      }

      .dialog-gifts {
        width: 170px;
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        .gift-item {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 30px;
            margin: 0 5px;
          }
          color: #545455;
          font-family: 'Inter-Tight';
          font-size: 16px;
          font-style: italic;
          font-weight: bold;
          line-height: normal;
        }
      }
    }

    .dialog-close {
      width: 40px;
      height: 40px;
      margin-top: 32px;
    }
  }

  .pd-24 {
    padding-top: 24px;
  }

  .top-mg25 {
    margin-top: -25px;
  }

  .mt-60 {
    margin-top: 60px;
  }
}

// 转盘样式
.outher {
  width: 245px;
  height: 245px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  .wapper {
    width: 246px;
    height: 246px;
    border-radius: 50%;
    .part1 {
      position: absolute;
      width: 123px;
      height: 246px;
      right: 0;
      overflow: hidden;
      text-align: center;

      .text {
        position: absolute;
        top: 16px;
        left: 7%;
        transform: rotate(19deg);
        text-align: center;
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: left center;
      }

      .item.one {
        background-color: #fefaf3;
        z-index: 1;
      }

      .item.two {
        background-color: #fcefa2;
        transform: rotate(45deg);
        z-index: 2;
      }

      .item.three {
        background-color: #fefaf3;
        transform: rotate(90deg);
        z-index: 3;
      }

      .item.four {
        background-color: #fcefa2;
        transform: rotate(135deg);
        z-index: 4;
      }
    }

    .part2 {
      position: absolute;
      width: 123px;
      height: 246px;
      left: 0;
      overflow: hidden;

      .text {
        position: absolute;
        top: 16px;
        left: 55%;
        transform: rotate(-24deg);
        text-align: center;
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: right center;
      }

      .item.five {
        background-color: #fefaf3;
        transform: rotate(-135deg);
        z-index: 4;
      }

      .item.six {
        background-color: #fcefa2;
        transform: rotate(-90deg);
        z-index: 3;
      }

      .item.seven {
        background-color: #fefaf3;
        transform: rotate(-45deg);
        z-index: 2;
      }

      .item.eight {
        background-color: #fcefa2;
        z-index: 1;
      }
    }

    .part1,
    .part2 {
      .gotted {
        background-color: #ff5a4a !important;
        .text {
          .discount {
            color: #fcefa2 !important;
          }
        }
        > img {
          width: 45px;
        }
      }
    }
  }

  .text {
    font-size: 0;
    .discount {
      color: #f74100;
      text-align: center;
      font-family: 'Inter-Tight';
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
    }

    > img {
      width: 45px;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .recharge-root .dis-detail .dis-up {
    transform: rotateY(180deg);
  }
  .recharge-root .dis-detail .dis-bg {
    right: unset;
    left: -10px;
  }
  .recharge-root .dis-detail .item1 .dis-tit {
    text-align: right;
  }
  .recharge-root .dis-detail .item2 .dis-tit {
    text-align: right;
  }
  .recharge-root .rec-fir-deliver .deliver-l div {
    background: linear-gradient(90deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
  }
  .recharge-root .rec-fir-deliver .deliver-r div {
    background: linear-gradient(270deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
  }

  .recharge-root .recharge-btn .discount {
    right: unset;
    left: 0;
  }
  .recharge-root .mask .dialog .dialog-detail .dialog-up {
    transform: rotateY(180deg);
  }
  .recharge-root .mask .dialog .dialog-detail .dialog-bg {
    right: unset;
    left: 16px;
  }
  .recharge-root .mask .dialog .dialog-detail .item1 .dialog-tit {
    text-align: right;
  }
  .recharge-root .mask .dialog .dialog-detail .item2 .dialog-tit {
    text-align: right;
  }
  .recharge-root .mask .dialog .dialog-deliver .deliver-l div {
    background: linear-gradient(90deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
  }
  .recharge-root .mask .dialog .dialog-deliver .deliver-r div {
    background: linear-gradient(270deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
  }
}
</style>
